import React, { useEffect, useState } from 'react';
import { View, StyleSheet, FlatList } from 'react-native';
import ButtonDLSBase from '../../button/ButtonDLS.base';
import { ButtonSizeDLS, ButtonTypeDLS, ColorTokens, DividerSizeTokens, TypographyTypeDLS } from '@voltmoney/schema';
import Typography from '../../typography/Typography';
import Divider from '../../divider/Divider';
const ListItem = ({ bankData, setIfscNumber, setShowBankDetails, setShowIfscDetails, setIfscDescription, triggerAction, }) => {
    const [bankList, setBankList] = useState(bankData);
    useEffect(() => {
        setBankList(bankData);
    }, [bankData]);
    const renderItem = ({ item }) => {
        return (React.createElement(React.Fragment, null,
            React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' } },
                React.createElement(View, { style: { width: '65%' } },
                    React.createElement(Typography, { label: `${item?.bankCode?.BRANCH}, ${item?.bankCode?.ADDRESS}`, color: ColorTokens.Grey_Charcoal, typeDLS: TypographyTypeDLS.B2M }),
                    React.createElement(Typography, { label: item?.bankCode?.IFSC, color: ColorTokens.Grey_Night, typeDLS: TypographyTypeDLS.B1S })),
                React.createElement(View, { style: { width: '30%' } },
                    React.createElement(ButtonDLSBase, { sizeDLS: ButtonSizeDLS.MEDIUM, typeDLS: ButtonTypeDLS.SECONDARY, label: 'Select', onPress: async () => {
                            setIfscNumber(item?.bankCode?.IFSC);
                            setShowIfscDetails(false);
                            setShowBankDetails(true);
                            setBankList([]);
                            setIfscDescription(item?.bankCode?.BRANCH);
                        }, isDisabled: false, newArchButton: false }))),
            React.createElement(View, { style: { marginVertical: 12 } },
                React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk }))));
    };
    return (React.createElement(View, { style: { paddingHorizontal: 16 } },
        bankList?.length > 0 && (React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' } },
            React.createElement(Typography, { label: `Results (${bankList?.length})`, color: ColorTokens.Grey_Night, typeDLS: TypographyTypeDLS.B2R }),
            React.createElement(View, { style: { width: '35%' } },
                React.createElement(ButtonDLSBase, { sizeDLS: ButtonSizeDLS.MEDIUM, typeDLS: ButtonTypeDLS.TERTIARY, label: 'Clear results', onPress: () => {
                        setBankList([]);
                    }, isDisabled: false })))),
        React.createElement(View, { style: { marginTop: 20 } },
            React.createElement(FlatList, { data: bankList, renderItem: renderItem, keyExtractor: (item) => item.id }))));
};
const styles = StyleSheet.create({});
export default ListItem;
